import React from 'react'
import Link from 'gatsby-link'
import styled from 'styled-components'
import heroImage from '../images/hero.jpg'

const Hero = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background-image: url(${heroImage});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
`

const Container = styled.div`
  margin-left: auto;
  margin-right: auto;
  max-width: 52em;
  padding-left: 2rem;
  padding-right: 2rem;
`

const Heading = styled.h1`
  text-align: center;
  color: white;
  font-size: 2rem;

  @media (min-width: 52em) {
    font-size: 3rem;
  }
`

const Text = styled.div`
  text-align: center;
  color: white;
  font-size: 1.5rem;

  @media (min-width: 52em) {
    font-size: 2rem;
  }
`

const BackLink = styled(Link)`
  color: white;
  text-decoration: none;
`

const NotFoundPage = () => (
  <Hero>
    <Container>
      <Heading>
        Etsimääsi sivua ei löytynyt.
      </Heading>
      <Text>
        <BackLink to='/'>Palaa takaisin etusivulle &rarr;</BackLink>
      </Text>
    </Container>
  </Hero>
)

export default NotFoundPage



// WEBPACK FOOTER //
// ./src/pages/404.js